import React from 'react';
import { Typography } from '@material-ui/core';
import styles from './VisibilitySharing.module.css';

const RuleDescription = ({ description, expression }) => {
    const friendly = description || '';
    const raw = expression || '';
    if (!friendly && !raw) {
        return null;
    }

    const showFriendly = Boolean(friendly && friendly !== raw);

    return (
        <div className={styles.ruleBlock}>
            {showFriendly ? <Typography className={styles.ruleLine}>{friendly}</Typography> : null}
            {raw ? (
                <div className={styles.expressionBlock}>
                    <span className={styles.termLabel}>JSONata expression</span>
                    <pre className={styles.rawExpression}>{raw}</pre>
                </div>
            ) : (
                <Typography className={styles.ruleLine}>{friendly}</Typography>
            )}
        </div>
    );
};

export default RuleDescription;
